import React from 'react';
import { Download2Icon, DownloadExcelIcon } from 'assets/icons';
import { Globals } from 'utils';
import moment from 'moment';
import { Pagination, Input, DatePicker, Select, Button } from 'components';
import { ReportsService, GeneralService } from 'services';

type IonChangeEvent = React.ChangeEvent<HTMLInputElement>;

const INITIAL_STATE = {
  search: '',
  type: '',
  speciality: '',
  from: null,
  to: null
}

class PaymentsReceived extends React.Component {

  debounce?: NodeJS.Timeout;

  state = {
    form: INITIAL_STATE,
    specialties: [],
    doctors: [],
    data: [],
    appointmenTypes: [],
    pagination: {
      pages: 1,
      page: 1,
    },
  }

  componentDidMount(): void {
    this.getSelects()
    this.load()
  }

  load = async (page: number = 1, download: boolean = false, paymentId?: number) => {
    try {
      const { from, to } = this.state.form;
      const _from = from ? moment(from).format('YYYY-MM-DD') : '';
      const _to = to ? moment(to).format('YYYY-MM-DD') : '';

      let payload = { page, ...this.state.form, from: _from, to: _to, download } as any;
      if (paymentId) payload = { ...payload, id: paymentId };

      const res = await ReportsService.payemntsRecieved(payload)

      if (download) return res;

      const { data, ...rest } = res as any;
      this.setState({ data, pagination: rest });
    } catch (error) {
      const err = error as any;
      Globals.showError(err?.response?.data?.error ?? 'Ocurrió un error inesperado');
    }
  }

  download = async (paymentId?: number) => {
    try {
      const res: any = await this.load(this.state.pagination.page, true, paymentId);
      if (!res?.url) return;

      const link = document.createElement('a');
      link.href = Globals.fromStorage(res?.url);
      link.download = 'reporte.xlsx';
      link.target = '_blank';
      link.click();

    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  getSelects = async () => {
    const toSelect = (data: any) => data?.map((x: any) => ({ value: x.id, label: x.name })) ?? [];
    try {
      const specialities: any = await GeneralService.getSpecialties();
      const appointmentTypes: any = await GeneralService.getAppointmentTypes();
      this.setState({
        specialties: toSelect(specialities),
        appointmenTypes: toSelect(appointmentTypes),
      });
    } catch (error) {
      Globals.showError('Ocurrió un error inesperado');
    }
  }

  change = async (value: string | number | boolean, target: keyof typeof INITIAL_STATE) => {
    const form = Globals.clone(this.state.form);
    form[target] = value;
    form['from'] = form.from ? new Date(form.from) : null;
    form['to'] = form.to ? new Date(form.to) : null;
    await this.setState({ form });

    if (this.debounce) clearTimeout(this.debounce);
    this.debounce = setTimeout(async () => this.load(1), 800);
  }


  cleanFilters = async () => {
    await this.setState({ form: { ...INITIAL_STATE } });
    this.load(1);
  }


  render() {
    const { form, specialties, appointmenTypes } = this.state
    const canCleanFilters = JSON.stringify(this.state.form) !== JSON.stringify(INITIAL_STATE);

    return (
      <div id="payments-received">
        <section className="filters">
          <Input
            label="Buscar"
            placeholder="Nombre del médico"
            value={form.search}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'search')}
          />

          <Select
            label="Especialidad"
            name="speciality"
            className="select-filter"
            value={form.speciality}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'speciality')}
            options={specialties}
          />


          <Select
            label="Modalidad"
            name="type"
            className="select-filter"
            value={form.type}
            onChange={(e: IonChangeEvent) => this.change(e.target.value, 'type')}
            options={appointmenTypes}
          />

          <DatePicker
            label="Desde"
            placeholder="Desde"
            maxDate={form.to || moment().toDate()}
            onChange={(v: string) => this.change(v, 'from')}
            value={form.from}
          />
          <DatePicker
            label="Hasta"
            placeholder="Hasta"
            maxDate={moment().toDate()}
            minDate={form.from}
            onChange={(v: string) => this.change(v, 'to')}
            value={form.to}
          />
          {canCleanFilters && (
            <Button clear onClick={this.cleanFilters}>
              Limpiar
            </Button>
          )}
        </section>

        <div className="rg-table">
          <div className="rg-table-header">
            <p></p>
            <div className="rg-table-actions">
              <button onClick={() => this.download()}>
                <img src={Download2Icon} alt="Descargar" />
                <span>Descargar Excel</span>
              </button>
            </div>
          </div>
          <table>
            <thead>
              <tr>
                <th>Fecha de pago</th>
                <th>Fecha de la consulta</th>
                <th>Médico</th>
                <th>Especialidad</th>
                <th>Paciente</th>
                <th>Modalidad</th>
                <th>Precio de consulta ($)</th>
                <th>Método de pago</th>
                <th>Banco emisor</th>
                <th>Precio en Bs</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {this.state.data.map((payment: any, index: number) => {
                return (
                  <tr key={`patient-${index}`}>
                    <td>{moment(payment?.date).format('DD-MM-YYYY')}</td>
                    <td>{moment(payment?.appointment?.date).format('DD-MM-YYYY')}</td>
                    <td>{payment?.appointment?.doctor?.full_name}</td>
                    <td>{payment?.appointment?.doctor?.specialty?.name}</td>
                    <td>{payment?.user?.full_name}</td>
                    <td>{payment?.appointment?.type?.name}</td>
                    <td className='bold price'>{Globals.formatMiles(payment?.amount)}</td>
                    <td>{payment?.payment_method?.name}</td>
                    <td>{payment?.bank?.name}</td>
                    <td>{Globals.formatMiles(payment?.amount_local, true, 'Bs')}</td>
                    <td className='actions'>
                      <div>
                        <img
                          className='pointer'
                          src={DownloadExcelIcon}
                          alt="Descargar"
                          title="Descargar"
                          onClick={() => this.download(payment?.id)}
                        />
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          {!this.state.data.length && (
            <div className='no-items'>
              <p>No se encontraron resultados</p>
            </div>
          )}
        </div>

        <Pagination
          pages={this.state.pagination.pages}
          active={this.state.pagination.page}
          onChange={this.load}
        />
      </div>
    )
  }

}
export default PaymentsReceived;